export default __webpack_public_path__ + "media/images/show-21b04d47098e9806b46c0aa00ada6852.png";